import ChainLinkIcon from './ChainLinkIcon'

export default ChainLinkIcon
